export const DEPARTMENT_LIST_QUERY_PARAMS = {
  WITH_USERS: {
    with_users: 1,
  },

  WITHOUT_USERS: {
    with_users: 0,
  },
}
